import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaSearch, FaEdit, FaTrashAlt, FaGlobe } from 'react-icons/fa';
import { useArticles } from '../../hooks/useArticles';

function ArticleList() {
  const { articles, loading, deleteArticle } = useArticles();
  const [search, setSearch] = useState('');
  const [deleting, setDeleting] = useState(null);

  const filtered = articles.filter(a =>
    a.title.toLowerCase().includes(search.toLowerCase()) ||
    a.category.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Supprimer "${title}" ?`)) return;
    setDeleting(id);
    try {
      await deleteArticle(id);
    } catch {
      alert('Erreur lors de la suppression');
    } finally {
      setDeleting(null);
    }
  };

  return (
    <div>
      <div className="admin-page-header">
        <h1>Articles</h1>
        <Link to="/admin/articles/new" className="admin-btn admin-btn-primary">
          <FaPlus /> Nouvel article
        </Link>
      </div>

      <div className="admin-search-wrapper">
        <FaSearch />
        <input
          type="text"
          placeholder="Rechercher par titre ou catégorie..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="admin-search"
        />
      </div>

      {loading ? (
        <p style={{ color: '#888', textAlign: 'center', padding: '40px' }}>Chargement...</p>
      ) : (
        <div className="admin-card" style={{ padding: 0, overflow: 'hidden' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Titre</th>
                <th>Catégorie</th>
                <th>Date</th>
                <th style={{ width: '140px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(article => (
                <tr key={article.id}>
                  <td>
                    <Link to={`/admin/articles/${article.id}/edit`} style={{ color: '#32afe5', textDecoration: 'none', fontWeight: '500' }}>
                      {article.title}
                    </Link>
                    {article.translations && Object.keys(article.translations).length > 0 && (
                      <FaGlobe style={{ marginLeft: '6px', color: '#32afe5', fontSize: '12px' }} title={`${Object.keys(article.translations).length} traductions`} />
                    )}
                  </td>
                  <td>
                    <span style={{
                      background: '#f0f8ff', color: '#32afe5', padding: '3px 10px',
                      borderRadius: '12px', fontSize: '12px', fontWeight: '500',
                      textTransform: 'capitalize'
                    }}>
                      {article.category}
                    </span>
                  </td>
                  <td style={{ color: '#888', fontSize: '13px' }}>
                    {article.date ? new Date(article.date).toLocaleDateString('fr-FR') : '-'}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <Link to={`/admin/articles/${article.id}/edit`} className="admin-btn admin-btn-secondary" style={{ padding: '6px 10px', fontSize: '13px' }}>
                        <FaEdit /> Modifier
                      </Link>
                      <button
                        onClick={() => handleDelete(article.id, article.title)}
                        disabled={deleting === article.id}
                        className="admin-btn admin-btn-danger"
                      >
                        <FaTrashAlt />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ padding: '40px', textAlign: 'center', color: '#888' }}>
                    Aucun article trouvé
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ArticleList;
